import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Loader from '../../../Helper/loader/loader';
import './album.css';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    input: {
        display: 'none',
    },
    button: {
        fontSize: '20px',
        fontWeight: 'bold',
        background: '#4284f4',
        borderRadius: '12px',
        width: '30%',
        float: 'right',
        fontFamily: 'Ropa Sans',
        textTransform: 'capitalize',
        marginBottom: '30px',
    },
    firstRefresh: {
        display: 'inline-block',
        position: 'relative',
        width: '80px !important',
        height: '80px !important',
        marginTop: '200px',
        color: '#a534a6'
    },
    refresh: {
        display: 'inline-block',
        position: 'relative',
        width: '40px !important',
        height: '40px !important',
        marginTop: '20px',
        color: '#a534a6'
    },
    GridCss: {
        width: 'calc(100% + 11px)',
        margin: 0
    }
});

class AlbumAppView extends React.Component {
    constructor() {
        super();
        this.state = {
            src: '',
            isActive: false,
            total: '',
            currentCount: 12,
            offset: 12,
            isFetching: false
        }
    }

    loadOnScroll = () => {
        let {currentCount, isFetching, offset, total} = this.state;
        if (currentCount === total) return;
        let el = document.getElementById('app-end');
        let rect = el.getBoundingClientRect();
        let isAtEnd = (
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        if (isAtEnd) {
            if (!isFetching) {
                this.setState({isFetching: true});
                setTimeout(() => {
                    let count = currentCount + offset;
                    if (currentCount !== total) {
                        this.setState({
                            isFetching: false,
                            currentCount: count,
                            albums: this.props.albumData.ImagesList.slice(0, count)
                        })
                    }
                }, 2000);
            }
        }
    };

    show = (src) => {
        let modal = document.getElementById('myModal');
        modal.style.display = "block";
        this.setState({
            src: src
        });
    };
    closes = () => {

        let modal = document.getElementById('myModal');
        modal.style.display = "none";
        this.setState({
            src: ''
        })
    };
    checkFormat = (url) => {
        let arr = url.split('.');
        return arr[arr.length - 1];
    };
    render() {
        const {classes, albumData, albumAllData} = this.props;
        const {src, currentCount, total} = this.state;
        return (
            <div className='album-css'>
                <div id="myModal" className="modal">
                    <span className="close" onClick={this.closes}
                          style={{marginTop: '4%', fontSize: '60px'}}>&times;</span>
                    <img alt="appImage" className="modal-content" id="img01" src={src}/>
                </div>
                <div>
                    <div
                        className={albumAllData.album.TotalRecords !== 0 ? "mobileView-css" : "no-album"}
                        onScroll={() => total > currentCount ? this.loadOnScroll() : ''}
                    >
                        {
                            albumAllData.album.TotalRecords === 0 &&
                            <div className="no-images-appview">Upload your first image.</div>
                        }
                        {albumAllData.album.TotalRecords !== 0 &&
                        <Grid container spacing={24} className={classes.GridCss}>
                            <div style={{width: "100%"}}>
                                {albumData && albumData.ImagesList && albumData.ImagesList.map((v, i) => {
                                    return (
                                        <div className="mobile-images" key={i}>
                                            {
                                                v.ImageUrl.length > 1000 ?
                                                    v.isImage === 'NO' ?
                                                        <div style={{display: 'inherit'}}>
                                                            <video id="video">
                                                                <source src="sintel-trailer.ogv"
                                                                        type='video/ogg; codecs="theora, vorbis"'/>
                                                                <source src={v.ImageUrl}
                                                                        type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>

                                                            </video>
                                                            <img alt="appImage"
                                                                 src={require('../../../images/play-button.png')}
                                                                 className="albun-video-play-icon-custom-position"/>
                                                        </div>
                                                        :
                                                        <img src={`data:image/jpeg;base64,${v.ImageUrl}`}
                                                             alt="uploaded"/>
                                                    :
                                                    (this.checkFormat(v.ImageUrl)) !== 'jpeg' ?
                                                        <div style={{display: 'inherit'}}>
                                                            <video id="video">
                                                                <source src="sintel-trailer.ogv"
                                                                        type='video/ogg; codecs="theora, vorbis"'/>
                                                                <source src={v.ImageUrl}
                                                                        type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'/>

                                                            </video>
                                                            <img alt="appImage"
                                                                 src={require('../../../images/play-button.png')}
                                                                 className="albun-video-play-icon-custom-position"/>
                                                        </div>
                                                        :
                                                        <img src={v.ImageUrl} alt="uploaded"/>
                                            }
                                        </div>
                                    )
                                })}
                                {
                                    albumAllData.album.TotalRecords !== undefined
                                        ?
                                        albumAllData.album.TotalRecords > 0 &&
                                        albumAllData.album.TotalRecords > albumAllData.albumLength ?
                                            <div className="app-Loader"><Loader/></div>
                                            :
                                            <React.Fragment/>
                                        :
                                        <div className="app-Loader">
                                            <Loader/>
                                        </div>
                                }
                            </div>
                        </Grid>}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        albumData: state.albums.album,
        albumAllData: state.albums,

    };
};

export default connect(mapStateToProps, null)(withStyles(styles)(AlbumAppView));